var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.87,
    fillRule: "nonzero",
    d: "M7 2.867c.336 0 .65.087.946.26a1.934 1.934 0 0 1 .96 1.646A1.934 1.934 0 0 1 7 6.68a1.934 1.934 0 0 1-1.906-1.906A1.934 1.934 0 0 1 7 2.867zm0 5.094c.58 0 1.113-.143 1.601-.427a3.168 3.168 0 0 0 1.16-1.16 3.121 3.121 0 0 0 .426-1.6c0-.58-.142-1.114-.427-1.602a3.168 3.168 0 0 0-1.159-1.159A3.121 3.121 0 0 0 7 1.586c-.58 0-1.113.142-1.601.427a3.168 3.168 0 0 0-1.16 1.16 3.121 3.121 0 0 0-.426 1.6c0 .58.142 1.114.427 1.602.284.488.67.874 1.159 1.159A3.121 3.121 0 0 0 7 7.96zM7 0a7.437 7.437 0 0 1 5.406 2.288A7.462 7.462 0 0 1 14 4.773a7.379 7.379 0 0 1-1.594 2.479A7.486 7.486 0 0 1 7 9.532a7.486 7.486 0 0 1-7-4.759 7.462 7.462 0 0 1 1.594-2.485A7.437 7.437 0 0 1 7 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeBlack);
export default __webpack_public_path__ + "static/media/eye_black.e48ab307578d19d582e69687e8de0d58.svg";
export { ForwardRef as ReactComponent };